import React from "react";
import Header from "./Header";

/**
 * Handle error page for front.
 */
function ErrorPage(props) {
  let errorMessage = "";
  if (props.message) {
    errorMessage = /*#__PURE__*/React.createElement(React.Fragment, null, " ", ": ", /*#__PURE__*/React.createElement("em", null, props.message));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "main"
  }, /*#__PURE__*/React.createElement(Header, Object.assign({}, props, {
    dataLoaded: true,
    ui_show_login: false
  })), /*#__PURE__*/React.createElement("div", {
    className: "widgets full-screen-widget"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tout"
  }, /*#__PURE__*/React.createElement("div", {
    className: "support"
  }, /*#__PURE__*/React.createElement("div", {
    className: "corps"
  }, /*#__PURE__*/React.createElement("p", null, "D\xE9sol\xE9, l'application rencontre actuellement un probl\xE8me", " ", errorMessage, "."), /*#__PURE__*/React.createElement("p", null, "Vous pouvez essayer d'actualiser la page. Si cette page vous appara\xEEt plusieurs fois au m\xEAme endroit, vous pouvez signaler ce bug en allant sur", " ", /*#__PURE__*/React.createElement("a", {
    href: "https://gitlab.com/terristory/terristory/-/issues/new?issuable_template=bug_report"
  }, "cette page"), " ", "ou bien en envoyant un mail \xE0", " ", /*#__PURE__*/React.createElement("em", null, "contact@terristory.fr"), " qui d\xE9crit les \xE9tapes suivies pour aboutir \xE0 cette page."), /*#__PURE__*/React.createElement("p", null, "L'\xE9quipe de TerriSTORY\xAE vous prie de l'excuser pour la g\xEAne occasionn\xE9e."))))));
}
export default ErrorPage;